module.exports = __webpack_public_path__ + "img/6d38316.webp";